import React from "react";
import {
  Box,
  HStack,
  Flex,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useTheme,
} from "@chakra-ui/react";
import { useToastContext } from "../toastNotificationProvider/ToastNotificationProvider";
import { useNavigate } from "react-router-dom";
import { IoIosContact } from "react-icons/io";
import { FaSortDown } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { BsGlobe } from "react-icons/bs";
const UserName = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { addNotification } = useToastContext();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("mentorName");
    addNotification("You have been logged out successfully", "success", 4000);
    navigate("/");
  };

  const handleViewSite = () => {
    window.open("https://www.inspedu.in/");
  };

  return (
    <Menu placement="bottom-end">
      <MenuButton
        as={Box}
       
        borderRadius="8px"
        boxShadow="sm"
        border={theme.borders.custom}
        bg="white"
        h="50px"
        px={3}
        cursor="pointer"
        display="flex"
        alignItems="center"
      >
        <Flex justify="flex-end">
          <HStack>
            <IoIosContact size="20" />
            <Text fontSize="14px" color="rgba(0, 0, 0, 1)">
              {localStorage.getItem("mentorName")}
            </Text>
          </HStack>
          <FaSortDown size="15" />
        </Flex>
      </MenuButton>

      <MenuList
        boxShadow="md"
        borderRadius="8px"
        w="150px" 
        zIndex="10"
        p={2}
        spaceY="20"
      >
       <MenuItem
          fontSize={"14px"}
          icon={<BsGlobe size={"20px"} />}
          onClick={handleViewSite}
        >
          View Site
        </MenuItem>

        <MenuItem
          fontSize={"14px"}
          icon={<FiLogOut size={"20px"} />}
          onClick={handleLogout}
          mb={"16px"}
        >
          Log out
        </MenuItem>
       
      </MenuList>
    </Menu>
  );
};

export default UserName;
